import { render, staticRenderFns } from "./WrkAgentEdit.vue?vue&type=template&id=e5ba1cee"
import script from "./WrkAgentEdit.vue?vue&type=script&lang=js"
export * from "./WrkAgentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports